<template lang="pug">
.the-admin-nav
  v-navigation-drawer(
    v-model="nav"
    mobile-break-point="960"
    width="200"
    clipped
    app)
    v-toolbar.text-xs-center(flat)
      v-toolbar-title 功能選單
    v-divider
    v-list.pt-0(dense)
      v-list-tile(
        v-for="item in activeItems"
        :key="item.title"
        :to="item.to")
        v-list-tile-action
          v-icon {{ item.icon }}
        v-list-tile-content
          v-list-tile-title {{ item.title }}
</template>
<script>
import { mapGetters } from "vuex";
import REGIONS from "@/assets/tables/regions.json";

const items = [
  {
    title: "新增會員",
    icon: "add",
    to: { name: "admin-user-create" },
    permissions: [
      "super",
      "admin",
      "manager",
      "all_director",
      "north_director",
      "south_director",
      "director"
    ]
  },
  {
    title: "會員列表",
    icon: "people",
    to: { name: "admin-user-table" },
    permissions: [
      "super",
      "admin",
      "manager",
      "counselor",
      "all_director",
      "north_director",
      "south_director",
      "director"
    ]
  },
  {
    title: "搜尋會員",
    icon: "search",
    to: { name: "admin-user-search" },
    permissions: ["super", "admin", "manager", "counselor", "all_director"]
  },
  {
    title: "收據列表",
    icon: "receipt",
    to: { name: "admin-receipt-list" },
    permissions: [
      "super",
      "admin",
      "manager",
      "all_director",
      "north_director",
      "south_director",
      "director"
    ]
  },
  {
    title: "繳費回報列表",
    icon: "assignment",
    to: { name: "admin-report-list" },
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "店舖列表",
    icon: "shop",
    to: { name: "admin-shops" },
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "幹部列表",
    icon: "account_circle",
    to: { name: "admin-auth-panel" },
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "列印",
    icon: "print",
    to: { name: "admin-print" },
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "幹部文件",
    icon: "description",
    to: { name: "admin-file" },
    permissions: ["super", "admin", "manager", "counselor"]
  },
  // {
  //   title: '上傳文件',
  //   icon: 'cloud_upload',
  //   to: { name: 'admin-upload' },
  //   permissions: ['super', 'admin', 'manager']
  // },
  {
    title: "系統設定",
    icon: "security",
    to: { name: "admin-setting" },
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "修改密碼",
    icon: "security",
    to: { name: "admin-password-update" }
  },
  {
    title: "內容管理",
    icon: "post_add",
    to: { name: "cms" },
    permissions: ["super", "admin", "manager"]
  },
  {
    title: "SUPER",
    icon: "security",
    to: { name: "admin-super" },
    permissions: ["super"]
  },
  {
    title: "回到首頁",
    icon: "keyboard_return",
    to: { name: "home" },
    permissions: null
  }
];

export default {
  name: "TheAdminNav",
  data() {
    return {
      nav: null,
      items
    };
  },
  computed: {
    ...mapGetters("auth", ["role", "manageRegion"]),
    activeItems() {
      return items.filter(item => {
        if (item.title === "搜尋會員" && this.role === "director") {
          return this.manageRegion.length === Object.keys(REGIONS).length;
        } else {
          return item.permissions
            ? item.permissions.some(p => p === this.role)
            : true;
        }
      });
    }
  },
  methods: {
    route(name) {
      this.$router.push({ name });
    },
    toggle() {
      this.nav = !this.nav;
    }
  }
};
</script>
